import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import es from "./locales/es/translation.json";
import { getCurrentDomainConfig } from "./config/domains";
import { mergeTranslations } from "./utils/mergeTranslations";

// Base translations
const baseTranslations = {
  en,
  es,
};

// Get domain config and merge translations
const domainConfig = getCurrentDomainConfig();
console.log('i18n: Domain config:', domainConfig);

const mergedTranslations = mergeTranslations(baseTranslations, domainConfig);
console.log('i18n: Merged translations:', mergedTranslations);

// Convert to i18next resources format
const resources: { [locale: string]: { translation: any } } = {};
for (const locale in mergedTranslations) {
  resources[locale] = { translation: mergedTranslations[locale] };
}
console.log('i18n: Final resources:', resources);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
